import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { chatsAPI } from '../../services/chatsApi'

const Sidebar = ({ currentUser, mobile = false }) => {
  const location = useLocation()
  const [unreadTotal, setUnreadTotal] = useState(0)

  useEffect(() => {
    if (!currentUser) return

    const loadUnread = async () => {
      try {
        const response = await chatsAPI.unreadTotal()
        setUnreadTotal(response.data.total)
      } catch (err) {
        console.error('Error loading unread count:', err)
      }
    }

    loadUnread()
    const interval = setInterval(loadUnread, 60000)
    window.addEventListener('chats:updated', loadUnread)
    return () => {
      clearInterval(interval)
      window.removeEventListener('chats:updated', loadUnread)
    }
  }, [currentUser, location.pathname])

  if (!currentUser) return null

  const isActive = (path) => {
    return location.pathname.startsWith(path)
  }

  const handleLogout = (e) => {
    e.preventDefault()
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = '/users/sign_out'

    const csrfToken = document.querySelector('[name="csrf-token"]')?.content
    if (csrfToken) {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'authenticity_token'
      input.value = csrfToken
      form.appendChild(input)
    }

    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'delete'
    form.appendChild(methodInput)

    document.body.appendChild(form)
    form.submit()
  }

  const sidebarContent = (
    <>
      <ul className="nav flex-column">
        <li className="nav-item">
          <Link
            to="/projects"
            className={`nav-link ${isActive('/projects') ? 'active' : ''}`}
          >
            Проекты
          </Link>
        </li>
        {currentUser.roles?.includes('admin') && (
          <>
            <li className="nav-item">
              <Link
                to="/work_stages"
                className={`nav-link ${isActive('/work_stages') ? 'active' : ''}`}
              >
                Прайсы
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/users"
                className={`nav-link ${isActive('/users') ? 'active' : ''}`}
              >
                Пользователи
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/settings/edit"
                className={`nav-link ${isActive('/settings') ? 'active' : ''}`}
              >
                Настройки
              </Link>
            </li>
          </>
        )}
        <li className="nav-item">
          <Link
            to="/chats"
            className={`nav-link ${isActive('/chats') ? 'active' : ''}`}
          >
            Чаты
            {unreadTotal > 0 && (
              <span className="badge rounded-pill bg-danger ms-2">{unreadTotal}</span>
            )}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/archive"
            className={`nav-link ${isActive('/archive') ? 'active' : ''}`}
          >
            Архив
          </Link>
        </li>
      </ul>
      <div className={mobile ? "mt-auto pt-3 px-3 pb-3 border-top" : "px-3 pt-3 border-top"}>
        <div className="text-muted small mb-2">{currentUser.email}</div>
        <a
          href="/users/sign_out"
          onClick={handleLogout}
          className="btn btn-outline-danger btn-sm w-100"
        >
          Выйти
        </a>
      </div>
    </>
  )

  if (mobile) {
    return (
      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="sidebarOffcanvas"
        aria-labelledby="sidebarOffcanvasLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="sidebarOffcanvasLabel">
            Veduproект
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body p-0">
          <div className="sidebar bg-light h-100">
            <div className="sidebar-content">{sidebarContent}</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="d-none d-lg-block sidebar bg-light">
      <div className="sidebar-content">{sidebarContent}</div>
    </div>
  )
}

export default Sidebar
